import { axiosClient } from "@/shared/api/axios-client";
import type { BandejaAutorizacionPage } from "@/lib/types";

/**
 * Listado PAGINADO de solicitudes pendientes para el rol actual. El backend ya
 * filtra por nivel/rol/organización del usuario, y además aplica los filtros de
 * columna (server-side) y el paginado (page/pageSize) que se pasen como query
 * params. Devuelve el envelope {items, total, page, pageSize}.
 */
export async function listarBandejaAutorizacion(
  params: Record<string, string | number> = {},
): Promise<BandejaAutorizacionPage> {
  const { data } = await axiosClient.get<BandejaAutorizacionPage>(
    "/api/autorizacion/bandeja",
    { params },
  );
  return data;
}

/** Resultado por solicitud del lote de autorización. */
export interface AutorizarLoteItem {
  solicitudId: string;
  numeroSolicitud: number;
  ok: boolean;
  errorCodigo: string | null;
  errorMensaje: string | null;
}

export interface AutorizarLoteResultado {
  total: number;
  autorizadas: number;
  fallidas: number;
  resultados: AutorizarLoteItem[];
}

/**
 * Autoriza el nivel actual de VARIAS solicitudes de una vez. `fechaPago` (YYYY-MM-DD)
 * se aplica a las que estén en su último nivel (el backend la exige ahí). Éxito
 * parcial · devuelve el resultado por solicitud.
 */
export async function autorizarLote(
  solicitudIds: string[],
  fechaPago?: string | null,
): Promise<AutorizarLoteResultado> {
  const { data } = await axiosClient.post<AutorizarLoteResultado>(
    "/api/autorizacion/autorizar-lote",
    { solicitudIds, fechaPago: fechaPago ?? null },
  );
  return data;
}
